import { inject } from 'vue';
import { DirectUpload } from '@rails/activestorage';

export default function useUploader() {
  const uploadUrl = inject('uploadUrl');

  return {
    /**
     * @param {File} file
     * @returns {DirectUpload}
     */
    create(file) {
      return new DirectUpload(file, uploadUrl);
    },

    /**
     * @param {DirectUpload} upload
     * @returns {Promise<import("@rails/activestorage").Blob>}
     */
    upload(upload) {
      return new Promise((resolve, reject) => {
        upload.create((error, blob) => {
          if (error) {
            reject(error);
            return;
          }
          resolve(blob);
        });
      });
    }
  };
}
